<template>
    <div class="grid grid-cols-1 md:grid-cols-2 h-screen">
      <!-- Left Side -->
      <div class="bg-green-100 flex items-center justify-center p-10">
        <h1 class="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 text-center leading-relaxed" >
          Engineering every breath of tomorrow
        <br>
          with empathy, for homes, schools, and the future of families like yours
        </h1>
      </div>
  
      <!-- Right Side -->
      <div class="bg-white flex items-center justify-center p-10 border-l border-gray-200">
        <div class="text-center">
          <h2 class="text-2xl font-semibold mb-4 text-gray-700">Contact Information</h2>
          <p class="text-gray-600 text-lg">
            <strong>For Business Enquiries:</strong><br />
            <a href="mailto:contact@shvason.com" class="text-green-600 hover:underline">
              contact@shvason.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactInfo'
  }
  </script>
  